import rawPages from "@/content/raw-pages.json";

export type Block =
  | { t: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "li"; text: string }
  | { t: "img"; src: string; alt?: string }
  | { t: "a"; text: string; href: string };

const rawPageMap = rawPages as unknown as Record<string, Block[]>;

/** Rewrites an original wp-content URL to the locally imported media file. */
export function localMedia(url: string): string {
  if (!url) return url;
  if (url.startsWith("/media/")) return url;
  const file = url.split("/").pop();
  return file ? `/media/${file}` : url;
}

/** Rewrites an absolute source-site URL to an app-relative path. */
export function localHref(href: string): string {
  if (!href) return href;
  return href.replace(/^https?:\/\/loli\.org/, "").replace(/\/$/, "") || "/";
}

/** Faithful content blocks captured for a given page key, with media localized. */
export function pageBlocks(key: string): Block[] {
  const blocks = rawPageMap[key] ?? [];
  return blocks.map((block) =>
    block.t === "img"
      ? { ...block, src: localMedia(block.src) }
      : block.t === "a"
        ? { ...block, href: localHref(block.href) }
        : block,
  );
}

/** Only the paragraph/heading text of a page, useful for prose-style routes. */
export function pageProse(key: string): Block[] {
  return pageBlocks(key).filter((b) => b.t !== "img");
}

export function firstText(key: string, kind: Block["t"]): string | undefined {
  const found = pageBlocks(key).find((b) => b.t === kind);
  return found && "text" in found ? found.text : undefined;
}
